<div class="container-fluid">
    <div class="row">
        <div class="col-md-6 offset-md-3">
            <div class="card">
              <div class="card-content">
                <div class="card-body">
                  <markdown ngPreserveWhitespaces src="assets/kb/changelog.md"></markdown>
                </div>
              </div>
            </div>
          </div>
    </div>
</div>

